import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

const TABS = [
  { label: "Users", href: "/admin/users", matchPrefix: "/admin/users" },
  { label: "Activity", href: "/admin/activity", matchPrefix: "/admin/activity" },
] as const;

/** Route-aware tab bar shared across admin pages. */
export function AdminTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="inline-flex h-11 md:h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground mb-4">
      {TABS.map((tab) => {
        const isActive = location.pathname.startsWith(tab.matchPrefix);
        return (
          <button
            type="button"
            key={tab.href}
            onClick={() => { void navigate(tab.href); }}
            className={cn(
              "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-2.5 md:py-1.5 text-sm font-medium transition-all",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
              isActive
                ? "bg-background text-foreground shadow-sm"
                : "hover:text-foreground",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
